import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { find } from 'lodash';
import { nav } from '@layouts/nav/nav';
import { FuseSidebarService } from '@shared/@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@shared/@fuse/services/config.service';
import { AuthenticationService } from '@modules/auth/service/authentication.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { SessionService } from '@core/services/session.service';
import { UnSubscribable } from '@core/un-subscrible';
import { ThemeService } from '@core/services';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ToolbarComponent extends UnSubscribable implements OnInit {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    themeWhitelabels: any;
    currentLang = '';

    userName: string;

    public appKey: any = {};

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private authService: AuthenticationService,
        private localize: LocalizeRouterService,
        private sessionService: SessionService,
        private themeService: ThemeService
    ) {
        super();

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'au'
            },
            {
                id: 'cn',
                title: 'Chinese',
                flag: 'cn'
            }
        ];

        this.navigation = nav;
        this.currentLang = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE');

        if (this.sessionService.authenticatedUser) {
            this.userName = this.sessionService.authenticatedUser.email;
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config.pipe(takeUntil(this.unsubscribeAll)).subscribe((settings) => {
            this.horizontalNavbar = settings.layout.navbar.position === 'top';
            this.rightNavbar = settings.layout.navbar.position === 'right';
            this.hiddenNavbar = settings.layout.navbar.hidden === true;
        });

        // Set the selected language from default languages
        const currentLang = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE');
        if (currentLang) {
            this.selectedLanguage = find(this.languages, { id: currentLang });
        } else {
            this.selectedLanguage = find(this.languages, { id: this.localize.parser.currentLang });
        }
        this._translateService.use(currentLang);
        
    }

    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
        this.localize.changeLanguage(lang.id);
        this.sessionService.saveCurrentLang(lang.id);
    }


    logout(): void {
        this.authService.logout();
        this.themeService.loadDefaultTheme();
    }
}
